import { render } from "./AdDetailsBox.vue?vue&type=template&id=e00c89ec&scoped=true"
import script from "./AdDetailsBox.vue?vue&type=script&lang=js"
export * from "./AdDetailsBox.vue?vue&type=script&lang=js"

import "./AdDetailsBox.vue?vue&type=style&index=0&id=e00c89ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00c89ec"]])

export default __exports__